import { IconButton, MenuItem, MenuList, Paper, Popper, useTheme } from "@mui/material";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import React, { useContext, useEffect, useRef, useState } from "react";
import AppConstants from "../../common/AppConstants";
import UserProfileContext from "../../common/ProfileContext";
import { useGameVideo } from "../../context/GameVideoContext";
import HeadShot from "../../sharedComponents/profilePhoto/HeadShot";
import ReviewContentDialog from "../dialog/ReviewContentDialog";
import MediaCard from "./MediaCard";

const useStyles = makeStyles((theme) => ({
    gridItem: {
        [theme.breakpoints.up("sm")]: {
            padding: theme.spacing(1),
        },
        [theme.breakpoints.down("xs")]: {
            paddingBottom: theme.spacing(1),
        },
    },
    card: {
        height: "355px",
        border: `1px solid ${theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.051)" : "#e8e8e8"}`,
        boxShadow: `0px 3px 5px 2px ${theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.051)" : "rgba(0, 0, 0, 0.1)"}`,
        borderRadius: 16,
    },
    cardHeader: {
        height: "96px",
        overflow: "hidden",
        "& button": {
            padding: theme.spacing(0.5),
        },
        backgroundColor: theme.palette.mode === "dark" ? theme.palette.background.default : theme.palette.primary.light
    },
    cardContent: {
        height: "355px",
    },
    mainAvatar: {
        width: theme.spacing(8),
        height: theme.spacing(8),
        border: "2px solid #1D428A",
    },
    coachName: {
        fontWeight: "bolder",
        fontSize: "18px",
        textDecoration: "none",
    },
}));

export default function MediaCardList(props) {

    const classes = useStyles();
    const anchorRef = useRef(null);
    const { gameVideoConfigValues, handleGameVideoAction } = useGameVideo();
    const { jwtTokenDetails } = useContext(UserProfileContext);
    const [open, setOpen] = useState(false);
    const [fullName, setFullName] = useState(
        props.data && props.data.fullName
            ? props.data.fullName
            : {}
    );

    const [videoReturnDialog, setVideoReturnDialog] = useState(false);
    const [videoApproveDialog, setVideoApproveDialog] = useState(false);
    const theme = useTheme();
    let Name = fullName.firstName + " " + fullName.lastName;

    useEffect(() => {
        setFullName(
            props.data && props.data.fullName
                ? props.data.fullName
                : {}
        );
    }, [props.data]);


    const handleToggle = () => {
        setOpen(!open);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };


    const handleApproveVideoUpload = () => {
        setVideoApproveDialog(true);
    };

    const handleRejectVideoUpload = () => {
        setVideoReturnDialog(true);
    };

    return (
        <Grid size={{ xs: 12, sm: 6, md: 6, lg: 4, xl: 3 }} className={classes.gridItem}>
            <Card className={classes.card}>
                <CardHeader
                    className={classes.cardHeader}
                    avatar={
                        <React.Fragment>
                            <HeadShot
                                userName={props.data.userName}
                                coachName={Name}
                                className={classes.mainAvatar}
                                profilePhoto={
                                    props.data.personalDetails &&
                                        props.data.personalDetails.profilePhoto
                                        ? props.data.personalDetails.profilePhoto
                                        : ""
                                }
                            />
                        </React.Fragment>
                    }
                    title={
                        <Typography style={{ cursor: "pointer", color: "" }} variant="h6" component="h6">
                            {" "}
                            <span data-gaeventlabel={fullName.firstName + " " + fullName.lastName}
                                data-gaeventcategory="Coach Profile card click"
                                data-gaeventaction="Profile Name Click"
                                className={classes.coachName} onClick={() => !props.hideAction ? props.handleViewProfileClick(props.data.userName) : false}>
                                {" "}
                                {fullName.firstName} {fullName.lastName}{" "}
                            </span>
                        </Typography>
                    }
                    action={
                        <div>
                            <IconButton
                                ref={anchorRef}
                                aria-label="more"
                                aria-controls={open ? 'menu-list-grow' : undefined}
                                aria-haspopup="true"
                                onClick={handleToggle}
                            >
                                <MoreVertIcon/>
                            </IconButton>
                            <Popper style={{ zIndex: 1300 }} placement='bottom-end' open={open} anchorEl={anchorRef.current} role={undefined}>
                                {({ TransitionProps, placement }) => (
                                    <Paper>
                                        <ClickAwayListener onClickAway={handleClose}>
                                            <MenuList>
                                                <MenuItem onClick={handleApproveVideoUpload}>Approve</MenuItem>
                                                <MenuItem onClick={handleRejectVideoUpload}>Return</MenuItem>
                                            </MenuList>
                                        </ClickAwayListener>
                                    </Paper>
                                )}
                            </Popper>
                        </div>
                    }
                />
                <MediaCard
                    data={props?.data?.profileVideo}
                    jwtTokenDetails={jwtTokenDetails}
                />
            </Card>
            <ReviewContentDialog
                title="Return this Video/Game?"
                reviewMessageFunction={() => gameVideoConfigValues.returnedReasonVideo}
                onApproveOrReject={(note, sendMail) => {
                    setVideoReturnDialog(false);
                    handleGameVideoAction(props.data, AppConstants.REVIEW_STATUS.RETURNED, note)
                }}
                onClose={() => {
                    setVideoReturnDialog(false)
                }}
                open={videoReturnDialog}
                actionText="RETURN"
                showNotifyCheck={false}
            />
            <ReviewContentDialog
                title="Approve this Video/Game?"
                reviewMessageFunction={() => gameVideoConfigValues.approvedReasonVideo}
                onApproveOrReject={(note, sendMail) => {
                    setVideoApproveDialog(false);
                    handleGameVideoAction(props.data, AppConstants.REVIEW_STATUS.APPROVED, note)
                }}
                onClose={() => {
                    setVideoApproveDialog(false)
                }}
                open={videoApproveDialog}
                actionText="APPROVE"
                showNotifyCheck={false}
            />
        </Grid >
    );
}
